import OrbitApiV1 from '.'

class CacheAPI {
  static getCachedOrgDetails(orgId) {
    return OrbitApiV1.httpGet(`/cache/${orgId}`)
  }

  static setCache(details, headers = {}) {
    return OrbitApiV1.httpPost(`/cache`, headers, details)
  }
}

export default CacheAPI
